import HTML5VideoHelper from '../../00_utilities/helpers/HTML5VideoHelper';
import YoutubeHelper from '../../00_utilities/helpers/YoutubeHelper';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';
import CookieHelper from '../../00_utilities/helpers/CookieHelper';

class Video {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-md': 992,
        };
        this.aboveBreakpoint = BreakpointHelper.aboveBreakpoint(this.breakpoints['screen-md']);
        this.autoplay = this.elem.getAttribute('data-autoplay') === 'true'
            || this.elem.getAttribute('data-autoplay') === '1';
        this.videoUrl = this.elem.getAttribute('data-embed');
        this.youtubeId = this.videoUrl ? YoutubeHelper.youTubeGetID(this.videoUrl) : '';
        this.videoContainer = this.elem.querySelector('.video__container');
        this.showControls = this.elem.getAttribute('data-controls') === 'true'
            || this.elem.getAttribute('data-controls') === '1';
        this.audio = this.elem.getAttribute('data-audio') === 'true'
            || this.elem.getAttribute('data-audio') === '1';
        this.videoSettings = {
            container: this.videoContainer,
            videoURL: this.videoUrl,
            youtubeId: this.videoUrl ? YoutubeHelper.youTubeGetID(this.videoUrl) : '',
            hideControls: !this.showControls,
            audio: this.audio,
        };
    }

    init() {
        if (this.videoUrl && this.videoUrl.length) {
            if (this.videoUrl.indexOf('youtube') >= 0) {
                this.initializeYoutubeConsent();

                return;
            }
            this.initializeHtmlVideo();
        }
    }

    initializeYoutubeConsent() {
        let showConsent = true;

        // if approved before or marketing cookies are approved
        if (window.youtubeConsentGiven
            || CookieHelper.getCookieValue('consent-type-marketing') === 'true'
            || CookieHelper.getCookieValue('consent-type-youtube')) {
            showConsent = false;
        }

        if (!showConsent) {
            YoutubeHelper.displayYoutubeVideo(this.elem);
            this.initializeYoutubeVideo();

            return;
        }

        this.elem.addEventListener('click', () => {
            this.autoplay = true;
            CookieHelper.setCookie('consent-type-youtube', true);
            YoutubeHelper.dispatchConsentEvent();
            this.initializeYoutubeVideo();
        }, { once: true });
    }

    initializeYoutubeVideo() {
        if ((this.autoplay && this.aboveBreakpoint) || this.elem.closest('.lightbox__content')) {
            this.autoplayVideoWhenVisible('youtube');

            return;
        }

        this.elem.addEventListener('click', () => {
            this.elem.classList.add('video--loading-animation');
            YoutubeHelper.addAndAutoplayVideo(this.videoSettings);
        }, { once: true });
    }

    initializeHtmlVideo() {
        if (this.autoplay) {
            if (this.elem.closest('.stage') || this.elem.closest('.lightbox__content')) {
                this.videoSettings.container = this.elem;
            }
        }

        if ((this.autoplay && this.aboveBreakpoint) || this.elem.closest('.lightbox__content')) {
            this.autoplayVideoWhenVisible('mp4');

            return;
        }

        this.elem.addEventListener('click', () => {
            this.elem.classList.add('video--loading-animation');
            HTML5VideoHelper.addAndAutoplayVideo(this.videoSettings);
        }, { once: true });
    }

    autoplayVideoWhenVisible(type) {
        if (!AccessibilityHelper.prefersReducedMotion()) {
            const options = {
                rootMargin: `${GeneralHelper.getPageHeaderHeight() * -1}px 0px 0px 0px`,
            };

            const observer = new IntersectionObserver((entries, self) => {
                const isIntersecting = typeof entries[0].isIntersecting === 'boolean'
                    ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;

                if (isIntersecting) {
                    switch (type) {
                        case 'youtube':
                            YoutubeHelper.addAndAutoplayVideo(this.videoSettings);
                            break;
                        default:
                            HTML5VideoHelper.addAndAutoplayVideo(this.videoSettings);
                            break;
                    }

                    self.unobserve(this.elem.querySelector('.video__container'));
                }
            }, options);

            observer.observe(this.elem.querySelector('.video__container'));
        }
    }
}

export default Video;
